import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-check-format-options',
    templateUrl: './check-format-options.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [FormBuilder],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckFormatOptionsComponent implements OnInit {
    readonly FORMAT_ONE_PER_PAGE = 'one-per-page';
    readonly FORMAT_THREE_PER_PAGE = 'three-per-page';

    readonly formatOptions = [
        { value: this.FORMAT_ONE_PER_PAGE, label: 'One per page', image: 'assets/images/app/check_voucher_1.png' },
        { value: this.FORMAT_THREE_PER_PAGE, label: 'Three per page', image: 'assets/images/app/check_voucher_3.png' },
    ];

    trackByValue(_index: number, option: { value: string }): string {
        return option.value;
    }

    formatForm: FormGroup = new FormGroup({
        format: new FormControl(this.FORMAT_ONE_PER_PAGE),
        displayBankAccount: new FormControl(false),
        displayPayor: new FormControl(false),
        displayCheckNumber: new FormControl(false),
        displayMemo: new FormControl(false),
        displayVendorAddress: new FormControl(false)
    });

    constructor(private _formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
    }

    /**
     * Get the current format values
     */
    getFormatValues(): any {
        const formValues = this.formatForm.getRawValue();
        return {
            format: formValues.format,
            displayBankAccount: !!formValues.displayBankAccount,
            displayPayor: !!formValues.displayPayor,
            displayCheckNumber: !!formValues.displayCheckNumber,
            displayMemo: !!formValues.displayMemo,
            displayVendorAddress: !!formValues.displayVendorAddress
        };
    }

    /**
     * Set format values from parent component
     */
    setFormatValues(values: any): void {
        if (!values) {
            return;
        }

        this.formatForm.patchValue({
            format: values.format || this.FORMAT_ONE_PER_PAGE,
            displayBankAccount: !!values.displayBankAccount,
            displayPayor: !!values.displayPayor,
            displayCheckNumber: !!values.displayCheckNumber,
            displayMemo: !!values.displayMemo,
            displayVendorAddress: !!values.displayVendorAddress
        });
    }

    /**
     * Check if the form is valid
     */
    isValid(): boolean {
        return this.formatForm.valid;
    }
}
